import app from 'flarum/forum/app';
import Notification from 'flarum/components/Notification';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';
// import { isPermanentSuspensionDate } from '../helpers/suspensionHelper';

export default class PushFrontToGuestSuccessedNotification extends Notification {
  icon() {
    return '';
  }

  img() {
    return `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-zt-tj.png`;
  }

  href() {
    let post = this.attrs.notification.subject();
    if (!post) {
      return;
    }
      return app.route.post(post);
   
  }

  content() {
    const notification = this.attrs.notification;
    const title = notification.content().title;
    const myObject = notification.content().myObject;
    return app.translator.trans( 'dl_discussion_controller.forum.notices.user_text',
    {title:title,addExp:myObject.addExperience,addIntegra:myObject.addIntegra});

  }
}
